/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {DateCriterionModel} from './date-criterion.model';
import {DateCriterionContract} from '../../api/contracts/date-criterion.contract';

export class DateCriterionMapper {

    static fromDateCriterionContract(input: DateCriterionContract): DateCriterionModel {
        let model: DateCriterionModel;

        if (input != null) {
            model = {
                startDate: input?.startDate,
                endDate: input?.endDate
            };
        }
        return model;
    }

    static toDateCriterionContract(input: DateCriterionModel): DateCriterionContract {
        let contract: DateCriterionContract;

        if (input != null) {
            contract = {
                startDate: input?.startDate,
                endDate: input?.endDate
            };
        }
        return contract;
    }
}
